import { render, staticRenderFns } from "./RemoteInvite.vue?vue&type=template&id=965ff296&scoped=true&"
import script from "./RemoteInvite.vue?vue&type=script&lang=js&"
export * from "./RemoteInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965ff296",
  null
  
)

export default component.exports